import { Bell, MagnifyingGlass } from '@phosphor-icons/react';

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <header className="page-header" data-testid="page-header">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-medium tracking-tight font-['Plus_Jakarta_Sans'] text-[#0F172A]" data-testid="page-title">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-[#64748B] mt-1">{subtitle}</p>
          )}
        </div>
        <div className="flex items-center gap-4">
          {actions}
          <button className="p-2 rounded-lg hover:bg-[#E2E8F0] transition-colors" data-testid="search-btn">
            <MagnifyingGlass size={20} className="text-[#64748B]" />
          </button>
          <button className="p-2 rounded-lg hover:bg-[#E2E8F0] transition-colors relative" data-testid="notifications-btn">
            <Bell size={20} className="text-[#64748B]" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-[#DC2626] rounded-full"></span>
          </button>
        </div>
      </div>
    </header>
  );
}
